import React from 'react'
import { useNavigate } from 'react-router-dom'
import { buildFileUrl } from '../../config/strapi'


interface RelatedNewsProps {
  noticias: any[]
  currentNoticiaId: number
  style?: React.CSSProperties
}

export function RelatedNews({ noticias, currentNoticiaId, style = {} }: RelatedNewsProps) {
  const navigate = useNavigate()

  // Filtrar notícias relacionadas (excluir a atual e pegar as 3 mais recentes)
  const relatedNoticias = noticias
    .filter((noticia: any) => noticia.id !== currentNoticiaId)
    .sort((a: any, b: any) => {
      const dateA = new Date(a.dataAtualizacao || a.updatedAt || 0)
      const dateB = new Date(b.dataAtualizacao || b.updatedAt || 0)
      return dateB.getTime() - dateA.getTime() // Ordem decrescente (mais recente primeiro)
    })
    .slice(0, 3)

  const handleNoticiaClick = (noticia: any) => {
    // Navega diretamente para a notícia pelo ID
    // Reason: Passa a origem 'noticias' para manter consistência com o fluxo de notícias
    navigate(`/noticia/${noticia.id}`, { state: { from: 'noticias' } })
  }

  if (relatedNoticias.length === 0) {
    return null
  }

  return (
    <div style={{
      marginTop: '3rem',
      ...style
    }}>
      {/* Título da seção */}
      <h2 style={{
        fontSize: '1.5rem',
        fontWeight: 700,
        color: '#0072BB',
        marginBottom: '1.5rem',
        textAlign: 'left'
      }}>
        Veja também
      </h2>

      {/* Lista de notícias relacionadas */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '1.5rem'
      }}>
        {relatedNoticias.map((noticia: any, index: number) => (
          <div key={noticia.id}>
            <div style={{
              display: 'flex',
              gap: '1.5rem',
              padding: '1rem 0',
              cursor: 'pointer',
              transition: 'background-color 0.2s ease',
              borderRadius: '8px'
            }}
            onClick={() => handleNoticiaClick(noticia)}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(0, 114, 187, 0.05)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent'
            }}>
              
              {/* Imagem da notícia */}
              <div style={{
                flexShrink: 0,
                width: '120px',
                height: '80px',
                borderRadius: '8px',
                overflow: 'hidden'
              }}>
                <img 
                  src={buildFileUrl(noticia.image?.url)}
                  alt={noticia.image?.alternativeText || 'Imagem da notícia'}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                />
              </div>

              {/* Conteúdo da notícia */}
              <div style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem'
              }}>
                {/* Tipo/Categoria */}
                <span style={{
                  color: '#0072BB',
                  fontSize: '0.8rem',
                  fontWeight: 500,
                  alignSelf: 'flex-start'
                }}>
                  {noticia.header?.type}
                </span>

                {/* Título */}
                <h3 style={{
                  fontSize: '1.1rem',
                  fontWeight: 600,
                  color: '#0072BB',
                  lineHeight: 1.3,
                  margin: 0,
                  textAlign: 'left'
                }}>
                  {noticia.header?.title}
                </h3>
                
                {/* Descrição */}
                <p style={{
                  fontSize: '0.9rem',
                  lineHeight: 1.4,
                  color: '#666',
                  margin: 0,
                  textAlign: 'left',
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden'
                }}>
                  {noticia.header?.description}
                </p>
              </div>
            </div>
            
            {/* Separador entre notícias */}
            {index < relatedNoticias.length - 1 && (
              <div style={{
                height: '1px',
                background: '#e0e0e0',
                margin: '0'
              }} />
            )}
          </div>
        ))}
      </div>
    </div>
  )
} 